'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = MenuIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuIcon(_ref) {
	var expanded = _ref.expanded,
	    className = _ref.className;

	// This is to prevent the `transform` animations
	// of menu icon bars from being played on page load.
	// (when styles are included on a page via javascript)
	var activated = expanded !== undefined;
	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames2.default)(className, 'rrui__menu-icon', {
				'rrui__menu-icon--collapsed': !expanded,
				'rrui__menu-icon--expanded': expanded
			}) },
		_react2.default.createElement('div', { className: 'rrui__menu-icon__bar' }),
		_react2.default.createElement('div', { className: 'rrui__menu-icon__bar' }),
		_react2.default.createElement('div', { className: 'rrui__menu-icon__bar' })
	);
}

MenuIcon.propTypes = {
	expanded: _propTypes2.default.bool,
	className: _propTypes2.default.string
};
//# sourceMappingURL=MenuIcon.js.map